export default __webpack_public_path__ + "static/media/milestone.fccc2832.png";